class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.openedByHover = false;
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', () => {
      this.openedByHover = false;
    });
    this.bindNestedHoverMenus();
  }

  bindNestedHoverMenus() {
    this.querySelectorAll('details[id^="Details-HeaderSubMenu-"]').forEach((details) => {
      const summary = details.querySelector('summary');

      details.addEventListener('mouseenter', () => {
        if (!this.hoverMediaQuery.matches) return;
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', true);
      });

      details.addEventListener('mouseleave', () => {
        if (!this.hoverMediaQuery.matches) return;
        details.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', false);
      });
    });
  }

  onMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;
    if (this.mainDetailsToggle.open) return;

    this.openedByHover = true;
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.hoverMediaQuery.matches || !this.openedByHover) return;
    if (this.contains(document.activeElement)) return;

    this.close();
    this.openedByHover = false;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.open) this.openedByHover = false;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }

  close() {
    super.close();
    this.querySelectorAll('details[id^="Details-HeaderSubMenu-"][open]').forEach((details) => {
      const summary = details.querySelector('summary');
      details.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);

document.addEventListener('click', (event) => {
  const summary = event.target.closest('header-drawer .menu-drawer__menu details > summary');

  if (!summary || !window.matchMedia('(max-width: 989px)').matches) return;

  const details = summary.parentElement;
  if (!details) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const isOpen = details.hasAttribute('open');
  details.classList.toggle('menu-opening', !isOpen);
  summary.setAttribute('aria-expanded', !isOpen);

  if (isOpen) {
    details.removeAttribute('open');
    details.classList.remove('menu-opening');
    details.querySelectorAll('details[open]').forEach((childDetails) => {
      const childSummary = childDetails.querySelector('summary');
      childDetails.removeAttribute('open');
      childDetails.classList.remove('menu-opening');
      if (childSummary) childSummary.setAttribute('aria-expanded', false);
    });
    return;
  }

  details.setAttribute('open', '');
}, true);
